import { irm_actionNotAllowedOnThisItem } from 'owa-locstrings/lib/strings/irm_actionnotallowedonthisitem.locstring.json';
import { itemHeaderPrint } from 'owa-locstrings/lib/strings/itemheaderprint.locstring.json';
import loc, { format } from 'owa-localize';
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { ClientItemId } from 'owa-client-ids';
import { onPrintRow } from 'owa-mail-module-orchestrator';
import { lazyPrint } from 'owa-mail-reading-pane-store';
import { ActionSource } from 'owa-analytics-actions';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';

import { action } from 'satcheljs/lib/legacy';

export default action('printItem')(async function printItem(
    itemId: ClientItemId,
    actionSource: ActionSource
) {
    const restrictionToConfirm = <IRMRestrictions>{ PrintAllowed: true };
    if (
        confirmItemActionAllowed(
            itemId.Id,
            restrictionToConfirm,
            format(loc(irm_actionNotAllowedOnThisItem), loc(itemHeaderPrint))
        )
    ) {
        lazyPrint.importAndExecute(itemId, actionSource);
        onPrintRow();
    }
});
